jQuery(document).on('ready', function () {

    // Timeout to allow ajax to load researchers in desktop version
    setTimeout( function(){
        var $ = jQuery;
        var maxSlidesToShow = 4;
        var loadMoreWhenFewerThan = 8;
        var sliderElementSelector = 'div.slide';


        /*****
         * SLICK EVENT for handling ajax. If the slider is near the end (determined by loadMoreWhenFewerThan remaining),
         * we will get more items.
         * Requirements: The slider container must have an ID
         * The slider entries must be selectable with sliderElementSelector
         */
        $(".front-end-slider.ajax").on('init', function (event, slick, currentSlide) {
            getNextIfNeeded(event, slick, 0, $(this));
        });
        $(".front-end-slider.ajax").on('afterChange', function(event, slick, currentSlide){
            getNextIfNeeded(event, slick, currentSlide, $(this));

        });

        function getNextIfNeeded(event, slick, currentSlide, slider) {
            if (slider.data('final-page-reached')) return;
            var currentPage = slider.data('current-page');
            if (!currentPage) {
                slider.data('current-page', 1);
            }
            var shouldGetNext = slick.slideCount - currentSlide < loadMoreWhenFewerThan;
            if (shouldGetNext) {
                slider.data('current-page', slider.data('current-page') + 1);
                getNext(slider, slider.data('current-page'));
            }
        }
        function getNext(slider, page) {
            var url = window.location.origin + window.location.pathname;
            var id = slider.attr('id');
            url += '?ajax_id=' + id + '&ajax_page=' + page;
            $.get(url, function (response) {
                var temp = $('<div />');
                temp.html(response);
                var elementContainer = temp.find('#' + id);
                var ajaxElements = elementContainer.find(sliderElementSelector);
                // no more - let's mark this as the last page
                if (ajaxElements.length == 0) {
                    slider.data('final-page-reached', true);
                }
                for (var i = 0; i < ajaxElements.length; i++) {
                    slider.slick('slickAdd', ajaxElements[i]);
                }
            });

        }

        $(".front-end-slider").slick({

            // normal options...
            dots: false,
            infinite: false,
            slidesToShow: maxSlidesToShow,
            slidesToScroll: maxSlidesToShow,
            adaptiveHeight: true,
            arrows: true,
            appendArrows: $('.front-end-buttons'),
            nextArrow: '<button class="slick-next icon-right" type="button" ></button>',
            prevArrow: '<button class="slick-next icon-left" type="button" ></button>',


            // the magic
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    appendArrows: $('#homepage-research-news, #channel-research-news')
                }
            }, {
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    appendArrows: $('#homepage-research-news, #channel-research-news')
                }

            }]
        });

        function addSliderToSection(section, sliderClass) {
            var mobileSliderContainer = section.prev('.mobile-slider');
            if (sliderClass) mobileSliderContainer.addClass(sliderClass);
            var slider = mobileSliderContainer.find('.mobile-slider-slider');
            var slides = section.find('.mobile-slide');

            var title = mobileSliderContainer.find('.mobile-slider-title');
            title.html(section.find('.section-heading').html());

            var readmoreLink = mobileSliderContainer.find('.mobile-slider-more-link');
            var sourceReadmoreLink = section.find('.more-archive-button, .all-researchers');
            var hasReadmore = sourceReadmoreLink.length > 0;
            if (hasReadmore) {
                readmoreLink.html(
                    $(section.find('.more-archive-button, .all-researchers')[0].outerHTML).removeClass('float-right')
                );
                mobileSliderContainer.addClass('has-more-link');
            } else {
                readmoreLink.remove();
            }


            var description = mobileSliderContainer.find('.mobile-slider-description');
            var sourceDescription = section.find('.section-description');
            if (sourceDescription.length > 0) {
                description.html(sourceDescription[0].outerHTML);
            } else {
                description.remove();
            }


            for (var i = 0; i < slides.length; i++) {
                slider.append(slides[i].outerHTML);
            }
            slider.slick({
                infinite: false,
                slidesToShow: 1,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                mobileFirst: true,
                responsive: [{
                    breakpoint: 480
                }]
            });
            slider.on('breakpoint', function (event, slick, breakpoint) {
                if (breakpoint) {
                    $(this).hide();
                } else {
                    $(this).show();
                    //slick.slickGoTo(0, true);
                }
            });
            return mobileSliderContainer;

        }

        $('.has-researcher-mobile-slider').each(function () {
            var section = $(this);
            var sliderContainer = addSliderToSection(section, 'researcher-slider');
            sliderContainer.find('.mobile-slider-description').append('<hr class="theme-divider">');
        });
        $('.has-mobile-slider').each(function () {
            var section = $(this);
            addSliderToSection(section);
        });
        var socialIcons = [];
        var suppress = false;
        jQuery(document).on('click', function() {
            if (!suppress) {
                socialIcons.map(function(icon) { jQuery(icon).removeClass("is-flex-important") });
                socialIcons = [];
            }
        });
        jQuery('.slick-slider').on('click', '.social-placeholder', function() {
            var currentElement = jQuery(this).next();
            var position = socialIcons.indexOf(currentElement.get(0));
            if (position === -1) {
                socialIcons.push(currentElement.get(0));
                currentElement.addClass("is-flex-important");
            } else {
                socialIcons.splice(position, 1);
                currentElement.removeClass("is-flex-important");
            }
            suppress = true;
            setTimeout(function() { suppress = false; }, 100);

        });

    }, 2000);
});
